<template>
  <div class="modal modal-save-container is-active" :class="[!getShowSaveModal ? 'fade-out': 'slide-in-fwd-center']">
    <div class="modal-background faded"></div>
      <div class="modal-content" v-clickoutside="handleClose">
        <div class="modal-box modal-save columns is-multiline">
          <button class="modal-close is-large" @click="setShowSaveModal(false), showFeedback = null" aria-label="close"></button>
          <div class="column is-12 modal-save-column flex-center">

            <!-- Start -->
            <div v-if="showFeedback === null" :class="{'fade-out': showFeedback !== null}" class="columns is-multiline">
              <div class="column is-12 sdg-graphic-container flex-center">
                <div class="modal-save-button flex-center" @click="saveFile()">
                  <icon class="large-svg flex fill-primary" name="cloud-download"></icon>
                  <span>{{$t('modal-save.saveFileButtonLabel')}}</span>
                </div>
              </div>
            </div>

            <!-- Spinner -->
            <div v-else-if="showFeedback" :class="{'fade-in': showFeedback}" class="column is-12 sdg-graphic-container">
              <div class="flex-center">
                <icon class="save-spinner-svg sdg-spinner flex" name="sdg-wheel"></icon>
              </div>
            </div>

            <!-- Loading done -->
            <div v-else class="columns is-multiline">
              <div class="column is-12 sdg-graphic-container flex-center">
                <div class="rotate-in-center">
                  <div class="saved-checkmark-circle flex-center">
                    <icon class="large-svg flex fill-green" name="checkmark"></icon>
                  </div>
                </div>
              </div>
              <div class="column is-12 flex-center flex-direction-column">
                <div>
                  <span class="spinner-saved-text">{{$t('modal-save.spinnerSavedFileName')}} </span><span class="spinner-saved-text semi-bold">{{getProject.name}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-12 flex-center">
            <div class="columns is-multiline">
              <div v-if="showFeedback" class="column is-12 flex-center fade-in">
                <span class="spinner-feedback-text">
                  {{$t('modal-save.spinnerFeedbackText')}}
                </span>
              </div>
              <div v-else class="column is-12 flex-center flex-direction-column">
                <span v-if="showFeedback === null" class="save-feedback-text">{{$t('modal-save.exitNoSave')}}</span>
                <span v-else class="save-feedback-text">{{$t('modal-save.exitWithSave')}}</span>
                <button class="button exit-button" @click="goToLanding()">{{$t('modal-save.exitFileButtonLabel')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import saveAs from 'file-saver'
import clickoutside from './../../../mixins/shared/clickoutside.js'

export default {
  name: 'modal-save',
  directives: { clickoutside },
  data () {
    return {
      showFeedback: null,
      closeModal: false
    }
  },
  computed: {
    ...mapGetters({
      getShowSaveModal: 'getShowSaveModal',
      getProject: 'getProject'
    })
  },
  watch: {
    getShowSaveModal (val, oldVal) {
      if (val !== oldVal && this.getShowSaveModal) {
        this.$nextTick(() => {
          this.closeModal = true
        })
      } else {
        this.closeModal = false
      }
    }
  },
  methods: {
    ...mapActions({
      setShowSaveModal: 'setShowSaveModal',
      setProjectTimestamps: 'setProjectTimestamps'
    }),
    goToLanding () {
      this.setShowSaveModal(false)
      this.$emit('goTo', 'landing')
      window.location.reload()
    },
    saveFile () {
      this.showFeedback = true
      let saveproject = JSON.parse(JSON.stringify(this.getProject))

      if (!saveproject.dateCreated) {
        saveproject.dateCreated = new Date()
      }

      saveproject.lastSaved = new Date()

      this.setProjectTimestamps({ dateCreated: saveproject.dateCreated, lastSaved: saveproject.lastSaved })

      saveproject.scenarios.forEach(scenario => {
        delete scenario['selected']

        scenario.goals = scenario.goals.filter(goal => goal.selected)
        scenario.goals.forEach(goal => {
          delete goal['selected']
        })
        for (const goal of scenario.goals) {
          goal.targets = goal.targets.filter(target => target.selected)
          goal.targets.forEach(target => {
            delete target['selected']
            delete target['description']
            delete target['displayCode']
            delete target['goalCode']
          })
        }
      })

      let blob = new Blob([JSON.stringify(saveproject)], { type: 'application/json' })
      setTimeout(() => {
        this.showFeedback = false
        saveAs(blob, this.getProject.name + '.nsdg')
      }, 3000)
    },
    handleClose ($event, el) {
      if (this.getShowSaveModal && this.closeModal) {
        this.setShowSaveModal(false)
        this.showFeedback = null
      }
    }
  }
}
</script>
